import { Col, Divider, Row } from "antd";

const Item = ({ label, value }) => {
  return (
    <div className="gx-mb-3">
      <Row>
        <Col span={12}>{label}</Col>
        <Col span={12}>{value}</Col>
      </Row>
      <Divider />
    </div>
  );
}

export default Item;